var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssFontSize,attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$root.loading),expression:"$root.loading"}],attrs:{"element-loading-text":_vm.loadingText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }